// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-menus {
  background-color: var(--menu-background-color);
  height: auto;
  min-height: 50em;
  align-items: left;
}

gridster {
  min-height: calc(100vh - (var(--header-height) + var(--toolbar-height)));
  background-color: var(--workspace-background-color);
}

.flex-gridster-item {
  display: flex;
  font-size: 16px;
  font-weight: bold;
}

.widget-item {
  border: solid 1px var(--widget-border-color);
  border-radius: 4px;
}

.flex-edit-widget {
  margin-inline-start: auto;
}

.item-icon {
  background-color: inherit;
  border: none;
}

.input-widget-name {
  border-bottom-style: solid;
  border-bottom-color: var(--widget-border-color);
  border-bottom-width: 1px;
  padding-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/dashboard/dashboard.component.scss"],"names":[],"mappings":"AACA;EACI,8CAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;;AAMA;EACI,wEAAA;EACA,mDAAA;AAHJ;;AAMA;EACI,aAAA;EACA,eAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,4CAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,YAAA;AAHJ;;AAMA;EACI,0BAAA;EACA,+CAAA;EACA,wBAAA;EACA,mBAAA;AAHJ","sourcesContent":["// Dashboard Toolbar configuration\n.side-menus {\n    background-color: var(--menu-background-color);\n    height: auto;\n    min-height: 50em;\n    align-items: left;\n}\n\n$parent-height: calc(var(--header-height) + var(--toolbar-height));\n\n// Gridster Formatting\ngridster {\n    min-height: calc(100vh - $parent-height);\n    background-color: var(--workspace-background-color)\n}\n\n.flex-gridster-item {\n    display: flex;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.widget-item {\n    border: solid 1px var(--widget-border-color);\n    border-radius: 4px;\n}\n\n.flex-edit-widget {\n    margin-inline-start: auto;\n}\n\n.item-icon {\n    background-color: inherit;\n    border: none;\n}\n\n.input-widget-name {\n    border-bottom-style: solid;\n    border-bottom-color: var(--widget-border-color);\n    border-bottom-width: 1px;\n    padding-top: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
